import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-liucheng",
  "use": "icon-liucheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-liucheng\"><defs><style type=\"text/css\"></style></defs><path d=\"M724.032 640V568H299.904V640H416v288h-320V640h116.032V480h256V395.584H352V96h320v299.584H555.968V480h256V640H928v288h-320V640h116.032z m115.968 88h-144v112h144v-112z m-512 0h-144v112h144v-112z m112-544v123.584h144V184h-144z\" p-id=\"10536\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol